import { render } from "./UserStats.vue?vue&type=template&id=61bc70e8"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./UserStats.vue?vue&type=style&index=0&id=61bc70e8&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__